import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp';
import type { NhapXuat } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<NhapXuat>[] => [
  { field: 'ma_nx', headerName: 'Mã nhập xuất', width: 150 },
  { field: 'ten_nx', headerName: 'Tên nhập xuất', width: 250 },
  {
    field: 'tk',
    headerName: 'Tài khoản',
    width: 100,
    renderCell: (params: DataTableRenderCellParams<NhapXuat>) => {
      return params.row.tk_data?.code;
    }
  }
];
